__turbopack_context__.v({
  "anchor": "action-control-module__FcBl9G__anchor",
  "control": "action-control-module__FcBl9G__control",
  "label": "action-control-module__FcBl9G__label",
  "srOnly": "action-control-module__FcBl9G__srOnly",
  "tooltip": "action-control-module__FcBl9G__tooltip",
  "tooltipEnter": "action-control-module__FcBl9G__tooltipEnter",
});
